import { useState } from 'react';
import { createPortal } from 'react-dom';
import { deleteWorkflowProjectProps } from '../../automator.props';
import BasicModal from '../../../../../components/action-modal';
import makeToast from '../../../../../components/toaster';
import Logout from '../../../../../auth/protected/session-expire-modal';
import { deleteExistingWorkflowProject } from '../../services';

function DeleteWorkflowProject({
  open,
  setDeleteWorkFlowProModalOpen,
  dataToDelete,
  setDataUpdated,
  setDataToDelete,
}: deleteWorkflowProjectProps) {
  const [logout, setLogout] = useState<boolean>(false);
  const handleCancelClick = () => {
    setDeleteWorkFlowProModalOpen(false);
    setDataToDelete(null);
  };

  const handleDeleteRole = () => {
    if (dataToDelete) {
      deleteExistingWorkflowProject(dataToDelete)
        ?.then((res) => {
          if (res.status === 200) {
            setDataUpdated((prev: boolean) => !prev);
            setDeleteWorkFlowProModalOpen(false);
            makeToast('success', 'Project has been deleted!');
            setDataToDelete(null);
          } else if (res.status === 401) {
            setLogout(true);
          }
        })
        .catch((err) => {
          setDeleteWorkFlowProModalOpen(false);
          makeToast(
            'error',
            err?.response?.data?.message
              ? `${err?.response?.data?.message}.`
              : 'Something went wrong!',
          );
          setDataToDelete(null);
        });
    }
  };

  return (
    <BasicModal
      className="w-[400px]"
      open={open}
      resetData={handleCancelClick}
      confirmButtonText="Delete"
      saveData={handleDeleteRole}
    >
      <span className="font-semibold text-center pb-3">
        Are you sure you want to delete selected project?
      </span>
      {logout && createPortal(<Logout />, document.body)}
    </BasicModal>
  );
}

export default DeleteWorkflowProject;
